export enum ModalMessages {
    Success = "Changes have been saved successfully.",
    Error = "An error has occurred while saving your changes. Please try again.",
    Unsaved = "You have unsaved changes, are you sure you want to cancel?"
}
